import React from "react";
import KickImage from 'Reuseables/KickImage';

/* ASSETS */
import ArrowsNext from "../../../../images/arrowsNext.png";

const ArrowsNextIcon: any = ArrowsNext

type PaymentCardProps = {
  image_url: string
  additional_class: string
  disabled: boolean | undefined
  choosePaymentHandler: () => void
}

const PaymentCard: React.FC<PaymentCardProps> = ({
  children,
  additional_class,
  image_url,
  disabled,
  choosePaymentHandler
}): JSX.Element => {
  return (
    <div
      onClick={() => !disabled && choosePaymentHandler()}
      className={`payment-card ${disabled ? "disabled" : ""}`}
    >
      {
        image_url &&
        <div className="icon-wrapper">
          <KickImage src={image_url} alt="..." />
        </div>
      }
      <div className={`text-wrapper ${additional_class}`}>
        {children}
      </div>
      <div className="arrow-wrapper">
        <KickImage src={ArrowsNextIcon} alt="..." />
      </div>
    </div>
  )
}

export default PaymentCard